/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Close from "../../../Helpers/CloseBtn/Close";
//import { useNavigate } from "react-router-dom";
import { popupcontext } from "../../../../context/Popupscontext";
import trans from "../../../../utils";
import { setHistoryPositions } from "../../../../Redux/service/Websocket";
import { useDispatch } from "react-redux";

export default function PlayBackTripHead({
	type,
	VehicleData,
	setPlayAllHist,
	setMinimizeAll,
	setMinimizeMediaPlayer,
	setMedia,
	setVId,
	HistoryPlayBack,
}) {
	let { setDisplay, setPosIndex, setHistoryPlayback, setShow, setIsPlaying } =
		useContext(popupcontext);
	//let navigate = useNavigate();
	const dispatch = useDispatch();
	const handleClose = async () => {
		await setDisplay(false);
		setHistoryPlayback({ state: false, Id: 0 });
		setPosIndex(0);
		setShow({ type: "playbackselection", value: true });
		setPlayAllHist(false);
		setPosIndex(0);
		setIsPlaying(false);
		setVId(null);
		HistoryPlayBack = [];
		dispatch(setHistoryPositions([]));
		//navigate("/livetracking");
	};
	const handleClosePlayer = () => {
		setPlayAllHist(false);
		setPosIndex(0);
		setIsPlaying(false);
	};
	const handleMinimzePlayback = () => {
		setMinimizeAll(true);
		setMedia(true);
		setPlayAllHist(true);
	};
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div className="history-playback-head">
				<div className="flex-between">
					{/* <img
						src={`${process.env.PUBLIC_URL}/assets/Double-arrow.svg`}
						alt="minimze"
						className="me-2 cursor"
						style={{ transform: lang !== "en" ? "rotate(-180deg)" : "" }}
						onClick={() =>
							type === "hist-player"
								? setMinimizeMediaPlayer(true)
								: handleMinimzePlayback()
						}
					/> */}
					<div className="fs-16 fw-600 me-2">
						{!type ? VehicleData?.name : trans("Track Player")}
					</div>
				</div>
				<div className="flex-between">
					{/* {!type && (
						<img
							src={`${process.env.PUBLIC_URL}/assets/Download2.svg`}
							alt="Download"
							className="mx-2"
						/>
					)} */}
					<Close
						style="close close-24"
						img="Close"
						close={!type ? handleClose : handleClosePlayer}
					/>
				</div>
			</div>
		</>
	);
}
